import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { generate } from "shortid";

import { PrimaryButton } from '../../../';
import Inputs from './Inputs';
import { WHITE, ORANGE } from '../../../styles/shared/colors';
import isValidMail from '../../../utils/isValidMail';
import "./InviteUserModal.scss";
import closeIcon from '../../../assets/imgs/icon-close.svg';

const reducer = (users, action) => {
  const { type, payload: { id, value } } = action;

  if (type === "new") {
    return [...users, { team: { name: "", id: "" }, email: "", id: generate() }];
  };

  if (type === "remove") {
    return [...users].filter(user => user.id !== id );
  }
  
  const index = users.findIndex(user => user.id === id);
  const usersCopy = [...users];
  usersCopy[index] = {
    ...users[index],
    [type]: value
  };
  return usersCopy;
}

const InviteUserModal = ({ onClose, title, onSend, teams }) => {
  const [users, dispatch] = useReducer(reducer, [{ team: { name: "", id: "" }, email: "", id: generate() }]);
  const [shouldDisplayError, setShouldDisplayError] = useState(false);

  const handleChangeEmail = (email, id, param) => {
    dispatch({
      type: param,
      payload: {
        id,
        value: email
      }
    });
  };

  const handlePickTeam = (team, id, param) => {
    dispatch({
      type: param,
      payload: {
        id,
        value: {
          name: team.name,
          id: team._id
        }
      }
    });
  }

  const handleAddNewInput = () => {
    dispatch({ type: "new", payload: {} });
  }

  const handleClick = () => {
    let hasErrors = false
    users.map(user => {// eslint-disable-line
      if (!isValidMail(user.email)) {
        hasErrors = true
      };
    })

    if (!hasErrors) {
      setShouldDisplayError(false);
      onSend(users);
    } else {
      setShouldDisplayError(true);
    }
  };

  const handleRemoveField = id => {
    dispatch({ type: "remove", payload: { id } });
  };

  return (
    <div className="invite-user-modal">
      <button className="invite-user-modal__close" type="button" onClick={onClose}>
        <img src={closeIcon} alt=""/>
      </button>
      <span className="invite-user-modal__title">{title}</span>
      <div className="invite-user-modal__inputs-container">
        {users.map((user, i) =>
          <Inputs
            key={user.id}
            id={user.id}
            email={user.email}
            hidePlusButton={users.length === i + 1}
            hideMinusButton={users.length === 1}
            onChangeEmail={handleChangeEmail}
            onAddInput={handleAddNewInput}
            teams={teams}
            onSelectTeam={handlePickTeam}
            onRemoveField={handleRemoveField}
          />
        )}
      </div>
      {shouldDisplayError &&
        <div className="invite-user-modal__error">
          <span>ooops, looks like not all emails are valid,</span>
          <span>please provide valid emails...</span>
        </div>
      }
      <div className="invite-user-modal__button-wrapper">
        <PrimaryButton
          color={WHITE}
          background={ORANGE}
          style={{ marginLeft: "15px" }}
          onClick={handleClick}
        >
          SEND
        </PrimaryButton>
      </div>
    </div>
  );
};

InviteUserModal.propTypes = {
  onClose: PropTypes.func,
  onSend: PropTypes.func,
  title: PropTypes.string
};

InviteUserModal.defaultProps = {
  onClose: () => { },
  onSend: () => { },
  title: ""
};

export default InviteUserModal;